/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Organize_3Inputs */

const en_pc_tut_organize_3 = /** @type {(inputs: Pc_Tut_Organize_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotate, delete, or insert blank pages or pages from another file with the page toolbar.`)
};

const zh_pc_tut_organize_3 = /** @type {(inputs: Pc_Tut_Organize_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用页面工具栏旋转、删除，或插入空白页及其他文件的页面。`)
};

/**
* | output |
* | --- |
* | "Rotate, delete, or insert blank pages or pages from another file with the page toolbar." |
*
* @param {Pc_Tut_Organize_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_organize_3 = /** @type {((inputs?: Pc_Tut_Organize_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Organize_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_organize_3(inputs)
	return zh_pc_tut_organize_3(inputs)
});
export { pc_tut_organize_3 as "pc.tut.organize.3" }